module.exports = __webpack_public_path__ + "static/media/blade-of-grass-depth.d2c6d5b8.jpg";